import { Injectable } from '@angular/core'
import { Http, Headers, Response, RequestOptions } from '@angular/http'
import 'rxjs/add/operator/toPromise'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { SeguridadService } from '../_services/seguridad.service'

import { AppSettings } from '../_models/settings.models'

@Injectable()

export class UsuariosService {

    constructor(private http: Http,
                private seguridad: SeguridadService
              ) { }

    getListaUsuarios(){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "AdminUserGetListaUsuarios", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getListaEmpresas(){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "AdminUserGetListaEmpresas", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getListaAccesos(id_usuario){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({id_user: id_usuario, tokenid: userToken, action: "AdminUserGetUserAccess", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getListaPermisos(id_usuario){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({id_user: id_usuario, tokenid: userToken, action: "AdminUserGetUserPermiss", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getListaRoles(){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({tokenid: userToken, action: "userGetUserRolesMaestra", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setListaRoles(id_role:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({id_role:id_role,tokenid: userToken, action: "userSetUserRole", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setNuevoRoleMaestro(descripcion:string){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({descripcion:descripcion,tokenid: userToken, action: "userSetNuevoRoleMaestro", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }    

    setUpdateRoleMaestro(id_role:number,descripcion:string){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({descripcion:descripcion,id_role:id_role,tokenid: userToken, action: "userUpdateRoleMaestro", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getRoleById(id_role:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({id_role:id_role,tokenid: userToken, action: "userGetRoleById", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getUsuarioListaPermisos(){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({tokenid: userToken, action: "userPermitList", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getListaPermisosAncep(tipo: string, id: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      let json: any = {
        tokenid: userToken,
        api_keytoken: AppSettings.API_KEYTOKEN
      }

      if (tipo == 'bloque'){
        json.action = "prodancepGetListaUsuariosBloques";
        json.id_bloque = id;
      }

      if (tipo == 'area'){
        json.action = "prodancepGetListaUsuariosAreas";
        json.id_area = id;
      }

      if (tipo == 'modulo'){
        json.action = "prodancepGetListaUsuariosModulos";
        json.id_modulo = id;
      }

      if (tipo == 'norma'){
        json.action = "prodancepGetListaUsuariosNormas";
        json.id_norma = id;
      }

      if (tipo == 'evidencia'){
        json.action = "prodancepGetListaUsuariosEvidencias";
        json.id_evidencia = id;
      }

      console.log(json);

      return this.http.post(AppSettings.API_URL, JSON.stringify(json))
          .map((response: Response) => {


              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setListaPermisosAncep(usuario: any){

      let userToken : string = localStorage.getItem('currentUserToken');

      usuario.tokenid = userToken;
      usuario.api_keytoken = AppSettings.API_KEYTOKEN;

      console.log(usuario);

      return this.http.post(AppSettings.API_URL, JSON.stringify(usuario))
          .map((response: Response) => {


              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }


    /*getReport(id_usuario: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post("http://dev.api.danubio.normapro.es/reports.php", JSON.stringify({id_user: id_usuario, tokenid: userToken, action: "userform", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              //if (!this.seguridad.getError(response)){ //si no hay error
              console.log(response);
                return response;

              //}

          });
    }*/

    getUsuario(id_usuario:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_user: id_usuario, tokenid: userToken, action: "AdminUserGetUser", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setUsuario(usuario: any){

      let userToken : string = localStorage.getItem('currentUserToken');

      usuario.tokenid = userToken;
      usuario.action = "AdminUserSetUser";
      usuario.api_keytoken = AppSettings.API_KEYTOKEN;


      return this.http.post(AppSettings.API_URL, JSON.stringify(usuario))
          .map((response: Response) => {

              console.log(response);

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setAcceso( acceso: any, id_usuario: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      acceso.tokenid = userToken;
      acceso.action = "AdminUserSetUserAccess";
      acceso.api_keytoken = AppSettings.API_KEYTOKEN;
      acceso.id_user = id_usuario;

      return this.http.post(AppSettings.API_URL, JSON.stringify(acceso))
          .map((response: Response) => {

              console.log(response);

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setPermiso( permiso: any, id_usuario: number){

      let userToken : string = localStorage.getItem('currentUserToken');

      permiso.tokenid = userToken;
      permiso.action = "AdminUserSetUserPermiss";
      permiso.api_keytoken = AppSettings.API_KEYTOKEN;
      permiso.id_user = id_usuario;

      return this.http.post(AppSettings.API_URL, JSON.stringify(permiso))
          .map((response: Response) => {

              console.log(response);

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/usuarios.service.ts